<template>
  <Block
    type="onestoreSubscribePageContainer"
    id="onestoreSubscribe"
    :class="$platformClass"
  >
    <Block tagName="div" type="subscribeManageDetailContent">
      <Block tagName="div" type="subscribeManageDetail">
        <Mark type="subscribeTitle">{{
          languages.onestore_subscribe_info_title
        }}</Mark>
        <one-sub-detail-desc-item
          v-bind="nowValidItemDetail"
        ></one-sub-detail-desc-item>
      </Block>
      <Block
        tagName="div"
        type="subscribeManageDetail"
        class="subscribe-manage-detail-2"
      >
        <Mark type="subscribeTitle">{{
          languages.onestore_subscribe_option_title
        }}</Mark>
        <one-sub-detail-time-item
          v-bind="nowValidItemDetail"
        ></one-sub-detail-time-item>
        <Button
          type="cancelSubscribe"
          class="select-way-btn"
          pointClass="j-cancel-subscribe"
          v-if="!isCancel"
          @click="showCancelSubPopup = true"
        >
          {{ languages.onestore_subscribe_cancel_subscribe }}
        </Button>
      </Block>
      <Block tagName="div" type="subscribeDetailTip">
        <Mark tagName="div" type="subscribeDetailTip" v-if="!isCancel">{{
          replaceDateAndPricesOfText({
            date: expiredTime,
            prices: prices,
            text: languages.onestore_subscribe_detail_tip,
          })
        }}</Mark>
        <Mark tagName="div" type="subscribeDetailTip" v-if="isCancel">{{
          replaceDateAndPricesOfText({
            date: expiredTime,
            prices: prices,
            text: languages.onestore_subscribe_has_cancel_tip1,
          })
        }}</Mark>
        <Mark tagName="div" type="subscribeDetailTip" v-if="isCancel">{{
          languages.onestore_subscribe_has_cancel_tip2
        }}</Mark>
      </Block>
    </Block>
    <one-sub-privacy :privacyLink="privacyLink"></one-sub-privacy>
    <PopupWindow
      type="confirm"
      @onCancel="showCancelSubPopup = false"
      @onConfirm="cancelSubscribe"
      v-if="showCancelSubPopup"
      :languages="languages"
      :content="
        replaceDateAndPricesOfText({
          date: expiredTime,
          prices: prices,
          text: languages.onestore_subscribe_popup_tip,
        })
      "
      :title="languages.onestore_subscribe_confirm_cancel"
      :cancel="languages.onestore_subscribe_later"
      :confirm="languages.onestore_subscribe_confirm"
    ></PopupWindow>
    <PopupWindow
      type="tips"
      @onCancel="showCancelFailPopup = false"
      @onConfirm="showCancelFailPopup = false"
      v-if="showCancelFailPopup"
      :languages="languages"
      :content="languages.onestore_subscribe_cancel_fail"
      :confirm="languages.onestore_subscribe_confirm"
      :title="languages.onestore_subscribe_cancel_fail_title"
    ></PopupWindow>
  </Block>
</template>
<script>
import OneSubPrivacy from '@components/passport/OneSubPrivacy';
import OneSubDetailDescItem from '@components/passport/OneSubDetailDescItem';
import OneSubDetailTimeItem from '@components/passport/OneSubDetailTimeItem';
import { mapState, mapGetters } from 'vuex';
import { CANCEL_SUBSCRIBE } from '@store/passport/onestoreSubscribe';
import { replaceDateAndPricesOfText } from '@utiles/index';
import globalConfig from '@utiles/globalConfig';
export default {
  name: 'onestoreSubscribeDetail',
  data() {
    return {
      showCancelSubPopup: false,
      showCancelFailPopup: false,
    };
  },
  computed: {
    ...mapState({
      languages: state => state.onestoreSubscribe.languages,
      privacyLink: state => state.onestoreSubscribe.privacyLink,
    }),
    ...mapGetters(['nowValidItemDetail']),
    isCancel() {
      return this.nowValidItemDetail.isCancel;
    },
    expiredTime() {
      return this.nowValidItemDetail.expiredTime;
    },
    prices() {
      return this.nowValidItemDetail.prices;
    },
    productId() {
      return this.nowValidItemDetail.productId;
    },
    orderId() {
      return this.nowValidItemDetail.orderId;
    },
  },
  methods: {
    cancelSubscribe() {
      this.$store
        .dispatch(CANCEL_SUBSCRIBE, {
          gameId:
            globalConfig.getHrefParam('gameId') ||
            globalConfig.getHrefParam('gameID') ||
            globalConfig.getHrefParam('game_id') ||
            '',
          productId: this.productId,
          orderId: this.orderId,
        })
        .then(({ cancelSucc }) => {
          this.showCancelFailPopup = !cancelSucc;
        });
    },
    replaceDateAndPricesOfText,
  },
  components: {
    OneSubPrivacy,
    OneSubDetailDescItem,
    OneSubDetailTimeItem,
  },
};
</script>
